import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"
import { Popup } from "components"

import { message, whiteTasks } from "state_management"
import useT from "utils/hooks/useT"
import { request } from "utils/request"

export default function IcalIntegration() {
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const dispatch = useDispatch()
  const members = useSelector((state) => state.members)

  const [icalLoading, setIcalLoading] = useState(false)
  const [result, setResult] = useState(null)

  return (
    <div className="IcalIntegration">
      {result && (
        <Popup onCancel={() => setResult(null)} title={tc("updatedIcalOutlook")}>
          {result.loadMembers.length ? (
            <h4>{tc("successfullyLoaded", { members: result.loadMembers.map((memberId) => members[memberId].initials).join(", ") })}</h4>
          ) : (
            <h4>{tc("noMembersLoaded")}</h4>
          )}
          {result.failedMembers.length > 0 && (
            <h4>{tc("failedLoading", { members: result.failedMembers.map((memberId) => members[memberId].initials).join(", ") })}</h4>
          )}
          <Button variant="primary" onClick={() => setResult(null)}>
            {tc("ok")}
          </Button>
        </Popup>
      )}
      <Button
        disabled={icalLoading}
        onClick={() => {
          setIcalLoading(true)
          request("POST", "/members/load-outlook/0")
            .then((res) => {
              setResult(res)
              dispatch(whiteTasks.fetch())
            })
            .catch((e) => {
              if (e.name === "IAPinUseError") {
                dispatch(message.warning(t("adhoc.iapRunning")))
              } else {
                dispatch(message.error(t("adhoc.failedLoadingIcalFiles")))
              }
            })
            .finally(() => setIcalLoading(false))
        }}
      >
        {icalLoading && <Spinner animation="grow" size="sm" />}
        {icalLoading ? ` ${tc("loading")}` : tc("updateIntegration")}
      </Button>
    </div>
  )
}
